import Header from './components/Header';
import Hero from './components/Hero';
import Sobre from './components/Sobre';
import Portfolio from './components/Portfolio';
import Diferenciais from './components/Diferenciais';
import Contato from './components/Contato';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <Header />
      <main>
        <Hero />
        <Sobre />
        <Portfolio />
        <Diferenciais />
        <Contato />
      </main>
      <Footer />
    </div>
  );
}
